export default __webpack_public_path__ + "static/media/top-up-history-web.ec0d8265.png";